export const ISSUES_FOR_FLITCHING_REQUEST = "ISSUES_FOR_FLITCHING_REQUEST";
export const ISSUES_FOR_FLITCHING_SUCCESS = "ISSUES_FOR_FLITCHING_SUCCESS";
export const ISSUES_FOR_FLITCHING_FAILED = "ISSUES_FOR_FLITCHING_FAILED";